module.exports = __webpack_public_path__ + "static/media/buildingConstruction21.3096d8c9.jpg";